import {ScreenId} from "@assets";

const constant = {
  MOBILE_WIDTH: 540,
  TABLET_WIDTH: 1024,
  CONTENT_DIV_ID: "content_div",
};

export default constant;
